import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
export const LoggedOutHome = () => {
  return (
    <>
      <video autoPlay muted loop className=" fixed bottom-0 bg-transparent w-full bg-black h-screen top-0 z-0">
        <source src="assets/last_day_in_saigon.mp4" type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>

      <div className="relative h-screen flex items-center flex-col justify-center  text-white z-10">
        <Helmet>
          <title>Hi 👋 | Podcast Vibe</title>
        </Helmet>
        <div className="w-full max-w-screen-sm px-5 text-center h-3/5 flex flex-col justify-between sm:h-3/6">
          <div className="font-extrabold tracking-wider flex flex-col justify-center items-center mt-10 sm:mt-0 sm:flex-row">
            <img src="assets/logo.png" alt="logo" className="w-20 sm:mr-10 sm:w-28" />
            <div className="flex flex-col justify-between text-center mt-10 sm:mt-0 sm:text-left sm:h-full sm:py-3">
              <div className="text-xl sm:text-2xl mb-2 sm:mb-0">Listion on</div>
              <div className="text-2xl sm:text-3xl font-bold">Pocast</div>
            </div>
          </div>
          <div>
            <div className="flex flex-col items-center">
              <div className="mb-5 w-full max-w-sm">
                <Link
                  to="/login"
                  className="flex justify-center py-3 rounded-lg font-bold text-white tracking-wider focus:outline-none bg-purple-700 hover:bg-purple-800 transition delay-75"
                >
                  Login
                </Link>
              </div>
              <div className="w-full max-w-sm">
                <Link
                  to="/create-account"
                  className="flex justify-center py-3 rounded-lg font-bold text-white tracking-wider focus:outline-none bg-pink-700 hover:bg-pink-800 transition delay-75"
                >
                  Create Account
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
